import React, {useEffect, useRef, useState} from "react";
import classNames from "classnames";

export const ScrollReveal = ({
    children,
    className,
    as = "div",
    threshold = 0.25,
    delay = 0,
    variant = "up",
    ...props
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!ref.current) {
            return;
        }

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.disconnect();
            }
        }, {
            threshold
        });

        observer.observe(ref.current);

        return () => observer.disconnect();
    }, [threshold]);

    return React.createElement(as, {
        ref,
        className: classNames("ScrollReveal", className, {
            "ScrollReveal--visible": isVisible,
            [`ScrollReveal--${variant}`]: variant
        }),
        style: {
            transitionDelay: `${delay}ms`
        },
        ...props
    }, children);
};

export default ScrollReveal;
